"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShorthandCloser = exports.getShorthandOpener = void 0;
var openers_1 = require("./openers");
var shorthandOpenersMap = {
    background: openers_1.openBackgroundShorthand,
    'border-radius': openers_1.openBorderRadiusShorthand,
    border: openers_1.openBorderShorthand,
    'border-top': openers_1.openBorderTopShorthand,
    'border-right': openers_1.openBorderRightShorthand,
    'border-bottom': openers_1.openBorderBottomShorthand,
    'border-left': openers_1.openBorderLeftShorthand,
    'border-style': openers_1.openBorderStyleShorthand,
    'border-width': openers_1.openBorderWidthShorthand,
    'border-color': openers_1.openBorderColorShorthand,
    outline: openers_1.openOutlineShorthand,
    'border-image': openers_1.openBorderImageShorthand,
    font: openers_1.openFontShorthand,
    'place-content': openers_1.openPlaceContentShorthand,
    'place-items': openers_1.openPlaceItemsShorthand,
    flex: openers_1.openFlexShorthand,
    'flex-flow': openers_1.openFlexFlowShorthand,
    margin: openers_1.openMarginShorthand,
    padding: openers_1.openPaddingShorthand,
    overflow: openers_1.openOverflowShorthand,
    gap: openers_1.openGapShorthand,
    'grid-gap': openers_1.openGridGapShorthand,
    'grid-row': openers_1.openGridRowShorthand,
    'grid-column': openers_1.openGridColumnShorthand,
    'grid-template': openers_1.openGridTemplateShorthand,
    grid: openers_1.openGridShorthand,
    'text-decoration': openers_1.openTextDecorationShorthand,
    'list-style': openers_1.openListStyleShorthand,
};
var shorthandClosersMap = {
    background: openers_1.closeBackgroundShorthand,
    'border-radius': openers_1.closeBorderRadiusShorthand,
    border: openers_1.closeBorderShorthand,
    'border-top': openers_1.closeBorderTopShorthand,
    'border-right': openers_1.closeBorderRightShorthand,
    'border-bottom': openers_1.closeBorderBottomShorthand,
    'border-left': openers_1.closeBorderLeftShorthand,
    'border-style': openers_1.closeBorderStyleShorthand,
    'border-width': openers_1.closeBorderWidthShorthand,
    'border-color': openers_1.closeBorderColorShorthand,
    outline: openers_1.closeOutlineShorthand,
    'border-image': openers_1.closeBorderImageShorthand,
    font: openers_1.closeFontShorthand,
    'place-content': openers_1.closePlaceContentShorthand,
    'place-items': openers_1.closePlaceItemsShorthand,
    flex: openers_1.closeFlexShorthand,
    'flex-flow': openers_1.closeFlexFlowShorthand,
    margin: openers_1.closeMarginShorthand,
    padding: openers_1.closePaddingShorthand,
    overflow: openers_1.closeOverflowShorthand,
    gap: openers_1.closeGapShorthand,
    'grid-gap': openers_1.closeGridGapShorthand,
    'grid-row': openers_1.closeGridRowShorthand,
    'grid-column': openers_1.closeGridColumnShorthand,
    'grid-template': openers_1.closeGridTemplateShorthand,
    grid: openers_1.closeGridShorthand,
    'text-decoration': openers_1.closeTextDecorationShorthand,
    'list-style': openers_1.closeListStyleShorthand,
};
var getShorthandOpener = function (prop) {
    var getOpener = shorthandOpenersMap[prop];
    return getOpener();
};
exports.getShorthandOpener = getShorthandOpener;
var getShorthandCloser = function (prop) {
    var getCloser = shorthandClosersMap[prop];
    return getCloser();
};
exports.getShorthandCloser = getShorthandCloser;
//# sourceMappingURL=shorthand-mapper.js.map